import Permissoes from "@/utils/permissoes";

import { formMode } from "@/utils/form.helpers";

const routes = [
    {
      path: "/locacoes",
      name: "locacoes",
      component: () => import("@/views/locacoes/index.vue"),
      meta: {
        title: 'Locações',
        authRequired: true,
        permissoes: [Permissoes.Locacoes],
        menus: [Permissoes.Locacoes]
      },
    },
    {
      path: "/locacoes/nova-locacao",
      name: "locacoes-nova-locacao",
      component: () => import("@/views/locacoes/form.vue"),
      meta: {
        title: 'Locações - Nova Locação',
        authRequired: true,
        formMode: formMode.Create,
        permissoes: [Permissoes.NovaLocacao],
        menus: [Permissoes.Locacoes]
      },
    },
    {
      path: "/locacoes/editar/:id",
      name: "locacoes-editar",
      component: () => import("@/views/locacoes/form.vue"),
      meta: {
        title: 'Locações - Editar Locação',
        authRequired: true,
        formMode: formMode.Create,
        permissoes: [Permissoes.EditarLocacoes],
        menus: [Permissoes.Locacoes]
      },
    },
  ];
  export default routes;

  